import { useCallback, useEffect, useMemo, useRef } from 'react';

export default function useKeypressListener({
  keyOrKeys,
  callback,
  condition = true,
  unmatchedCallback,
}: {
  keyOrKeys: string | string[];
  callback?: (key?: string) => void;
  condition?: boolean;
  unmatchedCallback?: (key?: string) => void;
}) {
  const keyEventType = useRef<string>('');
  const keys = useMemo<string[]>(() => (Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys]), [keyOrKeys]);

  // modify this to collect up string as I go as well - or implement key down and make sure it only uses one

  const handleKeypress = useCallback(
    (e: KeyboardEvent) => {
      // this is to ignore duplicate calls in the case where the input device supports both keydown and keypress events
      if (!keyEventType.current) keyEventType.current = e.type;
      else if (e.type != keyEventType.current) return;

      if (keys.includes(e.key)) callback?.(e.key);
      // will call this if it isn't enter
      else unmatchedCallback?.(e.key);
    },
    [keys, callback, unmatchedCallback],
  ) as EventListener;

  useEffect(() => {
    if (condition && callback) {
      // barcode scanners may emit keydown and/or keypress
      document.addEventListener('keydown', handleKeypress);
      document.addEventListener('keypress', handleKeypress);
    }

    return () => {
      document.removeEventListener('keydown', handleKeypress);
      document.removeEventListener('keypress', handleKeypress);
    };
  }, [condition, callback, handleKeypress]);
}
